module.exports = __webpack_public_path__ + "img/no-result.f2f0ba84.svg";